export default __webpack_public_path__ + "static/media/quechua.839d75ca.svg";